import React, { useState } from 'react';
import '../../../shared/StyledInput.css';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';

// closedStages: the Prospect Type's closed Stages (Disqualified, Lost and
// any Custom closed Stage) a reason can be tagged to.
function CloseReasonForm({ initial, closedStages, onSave, onCancel, loading }) {
  const [name, setName] = useState(initial?.name || '');
  const [stageIds, setStageIds] = useState(() => (initial?.relationship_stage_ids || []).map(Number));
  const [revisitMonths, setRevisitMonths] = useState(initial?.revisit_months ? String(initial.revisit_months) : '');
  const [error, setError] = useState('');

  const toggleStage = (id) => setStageIds((prev) => (prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]));

  const validate = () => {
    if (!name.trim()) return 'Name is required.';
    if (!stageIds.length) return 'Tag at least one closed Stage.';
    if (revisitMonths !== '' && !(Number.isInteger(Number(revisitMonths)) && Number(revisitMonths) >= 1 && Number(revisitMonths) <= 120)) {
      return 'Revisit period must be a whole number of months between 1 and 120.';
    }
    return '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validate();
    if (err) return setError(err);
    setError('');
    onSave({ name: name.trim(), relationship_stage_ids: stageIds, revisit_months: revisitMonths === '' ? null : Number(revisitMonths) });
  };

  return (
    <form onSubmit={handleSubmit} style={{ minWidth: 320, display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div>
        <label>Name<RequiredMark /></label><br />
        <input
          className="styled-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={100}
          placeholder="e.g., Went with a competitor"
          style={{ width: 300 }}
        />
      </div>

      <div>
        <label>Offered for<RequiredMark /></label>
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 4 }}>
          {closedStages.map((s) => (
            <label key={s.id} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 14 }}>
              <input type="checkbox" checked={stageIds.includes(s.id)} onChange={() => toggleStage(s.id)} />
              {s.name}
            </label>
          ))}
        </div>
      </div>

      <div>
        <label>Revisit period (months)</label><br />
        <input
          className="styled-input"
          type="number"
          min="1"
          max="120"
          value={revisitMonths}
          onChange={(e) => setRevisitMonths(e.target.value)}
          placeholder="None"
          style={{ width: 120 }}
        />
        <div style={{ fontSize: 12, color: '#5a6b85', marginTop: 4 }}>
          When set, closing with this reason asks for a revisit date, pre-filled this many months out.
        </div>
      </div>

      {error && <div style={{ color: 'red' }}>{error}</div>}

      <div>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default CloseReasonForm;
